import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';

/**
 * Vehicle insurance claim DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE_CLAIM)
export class VehicleInsuranceClaimSearchDto extends BaseSearchDto {
	files?: FileDto[];

	displayValue(): string | null {
		return `${this.id}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return null;
	}
}
